function ShopProductFilters({ categories, filters, onChange, onReset, resultCount }) {
  const update = (key) => (event) => onChange({ ...filters, [key]: event.target.value });
  const hasFilters = filters.query || filters.category !== "Alle" || filters.availability !== "all"
    || filters.minPrice !== "" || filters.maxPrice !== "" || filters.sort !== "newest";

  return (
    <div className="shop-product-filter-panel">
      <label className="shop-product-search">
        <span>Søg i butikken</span>
        <input type="search" value={filters.query} onChange={update("query")} placeholder="Søg efter en vare..." />
      </label>
      <div className="shop-product-filter-row">
        <label>Kategori<select value={filters.category} onChange={update("category")}><option>Alle</option>{categories.map((category) => <option key={category}>{category}</option>)}</select></label>
        <label>Lagerstatus<select value={filters.availability} onChange={update("availability")}><option value="all">Alle varer</option><option value="available">På lager</option><option value="out">Udsolgt</option></select></label>
        <label>Pris fra<input min="0" type="number" value={filters.minPrice} onChange={update("minPrice")} placeholder="0" /></label>
        <label>Pris til<input min="0" type="number" value={filters.maxPrice} onChange={update("maxPrice")} placeholder="Ingen grænse" /></label>
        <label>Sortér<select value={filters.sort} onChange={update("sort")}><option value="newest">Nyeste først</option><option value="price-asc">Laveste pris</option><option value="price-desc">Højeste pris</option><option value="title">Navn A–Å</option></select></label>
      </div>
      <div className="shop-product-filter-summary"><span>{resultCount} {resultCount === 1 ? "vare" : "varer"}</span>{hasFilters && <button type="button" onClick={onReset}>Nulstil filtre</button>}</div>
    </div>
  );
}

export default ShopProductFilters;
